import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanySettingForm } from "~/components/specifics/settings/company_settings/CompanySettingForm";
import type { ItandiAccount } from "~/models/ItandiAccount";

type Props = {
	session: ItandiAccount;
};

export function Page({ session }: Props) {
	if (session.company === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader title="会社情報設定" />
					<PanelBody>
						<CompanySettingForm companySetting={session.company} />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
